const FUSO_HORARIO = 'America/Sao_Paulo';

const formatadorDiaMes = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  timeZone: FUSO_HORARIO,
});

const formatadorDiaCalendario = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: FUSO_HORARIO,
});

function inicioDoDiaEmSaoPaulo(data: Date): number {
  const partes = formatadorDiaCalendario.formatToParts(data);
  const valorDe = (tipo: Intl.DateTimeFormatPartTypes): number =>
    Number(partes.find((parte) => parte.type === tipo)?.value ?? Number.NaN);

  return Date.UTC(valorDe('year'), valorDe('month') - 1, valorDe('day'));
}

export function formatarDiaMes(iso: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return '';
  return formatadorDiaMes.format(data);
}

export function diasAte(iso: string): number {
  const fim = new Date(iso);
  if (Number.isNaN(fim.getTime())) return Number.NaN;

  return Math.round((inicioDoDiaEmSaoPaulo(fim) - inicioDoDiaEmSaoPaulo(new Date())) / 86400000);
}
